import { render } from "./LoginError.vue?vue&type=template&id=2e5bed3a&ts=true"
import script from "./LoginError.vue?vue&type=script&lang=ts"
export * from "./LoginError.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__